module.exports = __webpack_public_path__ + "static/sja-cover-art-85ce6478409283f79635a0ffc423b892.jpg";